










import { Component, Vue, Prop } from 'vue-property-decorator';
import TemplateModal from '@/components/TemplateModal/TemplateModal.vue';
import eventBus from '@/utils/eventBus';
import APIService from '@/api';
import ManagerService from '@/api/ManagerService';

@Component({
  components: {
    TemplateModal
  }
})
export default class InviteModal extends Vue {
  @Prop({ required: false }) data!: any;
  @Prop({ required: false }) invite!: string;
  service = new ManagerService();

  get text() {
    if (this.data.isInvitedManager) {
      return `${this.data.inviter.fullname} invited you to ${
        this.data.isOwnerInvite ? 'be the owner of' : 'join their team at'
      } ${this.data.business.name}.`;
    }

    return `The invitation was sent to ${
      this.data.invitedMail
    }, but you’re currently logged into a different account`;
  }

  get confirmLabel() {
    if (this.data.isInvitedManager) {
      return 'Accept Invite';
    }

    return this.$t('common.buttons.logout');
  }

  get bottomText() {
    if (!this.data.isInvitedManager) {
      return 'Logout to create a new account, or request a new invitation to the correct email.';
    }

    return null;
  }

  closeModal() {
    eventBus.$emit('closeModal');
  }

  action() {
    if (this.data.isInvitedManager) {
      this.$showLoaderWithLocker();
      this.service
        .acceptInvite(this.invite)
        .then(res => {
          const { access_token } = res.data;
          this.service.setCredentials(access_token);
          window.location.assign('/');
        })
        .catch(() => {
          eventBus.$emit('closeModal');
          this.$hideLoader();
        });
    } else {
      APIService.resetCredentials(() => {
        window.location.assign(`/invite/${this.invite}`);
      });

      eventBus.$emit('closeModal');
    }
  }
}
